import { proxy } from 'valtio';
import {
	PagingConfig,
	PreworkCandidateFilter,
	PreworkGroupFilter,
	Batch,
} from '../../../shared/PreWorkServiceTypes';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';

export const CandidatesListState = proxy<{
	filterBy: PreworkCandidateFilter | undefined;
	paging: PagingConfig;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
});

export const MentorsListState = proxy<{
	filterBy: PreworkCandidateFilter | undefined;
	paging: PagingConfig;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
});

export const DashboardListState = proxy<{
	filterBy: PreworkCandidateFilter | undefined;
	paging: PagingConfig;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
});

export const DashboardDetailState = proxy<{
	filterBy: PreworkCandidateFilter | undefined;
}>({
	filterBy: undefined,
});

export const GraphViewListState = proxy<{
	filterBy: PreworkCandidateFilter | undefined;
	paging: PagingConfig;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
});

export const GroupsListState = proxy<{
	filterBy: PreworkGroupFilter | undefined;
	paging: PagingConfig;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
});

export const CandidatesBatchState = proxy<{
	selectedBatch: Batch | undefined;
}>({ selectedBatch: undefined });
